import React from "react";
import { Button, Modal } from "react-bootstrap";

interface RemoveStudentModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

const RemoveStudentModal: React.FC<RemoveStudentModalProps> = ({
  show,
  onHide,
  onConfirm,
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Ukloni učenika</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Jeste li sigurni da želite ukloniti učenika iz grupe?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onHide}>
          Odustani
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Ukloni
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveStudentModal;
